import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { EnvironmentLoader } from '../../../environments/utils/environment-loader.util';

@Injectable()
export class UserCreateService {
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    constructor(
        private http: HttpClient) {
    }

    // service: create a user when a new user signin at first time
    userCreate(username, headers?: any) {
        let body = JSON.stringify({
            USR_username: username
        });

        return this.http.post(
            `${EnvironmentLoader.environment.usersApi}/api/usercreate`,
            body,
            { headers: headers || this.headers });
    }
}
